/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Potvrdit nové heslo`
};

const da_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Bekræft ny adgangskode`
};

const de_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Neues Passwort bestätigen`
};

const en_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirm new password`
};

const es_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar nueva contraseña`
};

const fr_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmer le nouveau mot de passe`
};

const hu_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Új jelszó megerősítése`
};

const it_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Conferma nuova password`
};

const nl_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Bevestig nieuw wachtwoord`
};

const pl_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Potwierdź nowe hasło`
};

const pt_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Confirmar nova senha`
};

const sv_account_confirm_new_password = /** @type {(inputs: {}) => string} */ () => {
	return `Bekräfta nytt lösenord`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_confirm_new_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_confirm_new_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_confirm_new_password", locale)
	if (locale === "cs") return cs_account_confirm_new_password(inputs)
	if (locale === "da") return da_account_confirm_new_password(inputs)
	if (locale === "de") return de_account_confirm_new_password(inputs)
	if (locale === "en") return en_account_confirm_new_password(inputs)
	if (locale === "es") return es_account_confirm_new_password(inputs)
	if (locale === "fr") return fr_account_confirm_new_password(inputs)
	if (locale === "hu") return hu_account_confirm_new_password(inputs)
	if (locale === "it") return it_account_confirm_new_password(inputs)
	if (locale === "nl") return nl_account_confirm_new_password(inputs)
	if (locale === "pl") return pl_account_confirm_new_password(inputs)
	if (locale === "pt") return pt_account_confirm_new_password(inputs)
	return sv_account_confirm_new_password(inputs)
};
export { account_confirm_new_password as "account.confirm_new_password" }